
// NATIVE 

// INSTALLED 
import { setEmployeesContractsRedux, setEmployeRedux, setEmployesRedux } from './employeeSlice';
import { checkingPreload, unCheckingPreload } from '../loading';
import {
  activeEmployeService, desactiveEmployeService,
  getEmployeeDetailEditService,
  getEmployeeDetailService,
  getEmployesByPaginateService, getEmployesBySearchService, getEmployesDataCreateService,
  getEmployesService, saveEmployeeService, createMassiveEmployeeService,
  updateEmployeeService, verifyEmailService, entregarDotacionesService, downloadActaPdfService, downloadContractPdfService,
  downloadPdfEmployeeService
} from '../../services/employee.service';
import { setCompanySelectRedux } from '../company';
import { setCargosSelectRedux } from '../cargos';
import { setPaymentFrecuencySelectRedux } from '../payment_frequency';
import { setEpsSelectRedux } from '../eps';
import { setBancosSelectRedux } from '../associated_bank';
import { setCajaCompensacionSelectRedux } from '../family_compensation_fund';
import { setCesantiasSelectRedux } from '../severance';
import { setCajaArlSelectRedux } from '../arl';
import { setPensionSelectRedux } from '../pension';
import { setTipoDocumentoSelectRedux } from '../type_document';
import { setMetodoPagoSelectRedux } from '../payment_method';
import { setSucursalesSelectRedux } from '../sucursal';


// CUSTOM 
import { toCreateEmployeePayload, toEditEmployeePayload } from '../../pages/talento-humano/employee/mappers/employee.mapper';






export const startCreateMassiveEmployee = (file: File): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());
    const result = await createMassiveEmployeeService(file);
    dispatch(unCheckingPreload());
    return result;
  }
}

export const getEmployeStore = (status: number): any => {

  return async (dispatch: any) => {


    await dispatch(checkingPreload());

    const result = await getEmployesService(status);


    if (result.ok) {

      await dispatch(setEmployesRedux(result.data));
    }

    dispatch(unCheckingPreload());

    return result;


  }


}




export const getEmployesBySearch = (param: string, status: number = 1): any => {


  return async (dispatch: any) => {

    await dispatch( checkingPreload() );

    const result = await getEmployesBySearchService(param, status);


    if (result.ok) {

      await dispatch(setEmployesRedux(result.data));
    }

    dispatch(unCheckingPreload());

    return result;


  }


}





export const getEmployeDataCreateStore = (): any => {

  return async (dispatch: any) => {


    await dispatch(checkingPreload());

    const result = await getEmployesDataCreateService();


    if (result.ok) {

      await dispatch(dataCreateOrEditEmployee(result));

    }

    dispatch(unCheckingPreload());

    return result;


  }


}



export const getEmployesByPagination = (page: number, status: number = 1): any => {

  return async (dispatch: any) => {


    await dispatch(checkingPreload());



    const result = await getEmployesByPaginateService(page, status);


    if (result.ok) {
      await dispatch(setEmployesRedux(result.data));
    }

    dispatch(unCheckingPreload());

    return result;

  }

}




export const saveEmployee = (employee: any, percentage: any): any => {

  return async (dispatch: any) => {

    await dispatch(checkingPreload());


    const data_employee = toCreateEmployeePayload(employee);


    await dispatch(unCheckingPreload());

    const result = await saveEmployeeService(data_employee, percentage);


    return result;



  }
}







export const editEmployee = (employee: any, percentage: any): any => {

  return async (dispatch: any) => {

    await dispatch(checkingPreload());




    const data_employee = toEditEmployeePayload(employee);



    await dispatch(unCheckingPreload());

    const result = await updateEmployeeService(data_employee, percentage);


    if (result.ok) {
      await dispatch(storeShowDetailEmployeeEditar(data_employee.empleadoId));
    }


    return result;



  }
}






export const storeDesactiveEmploye = (employeId: string, value: string, pagePagination: number = 1, take: number = 10, status: number = 1): any => {


  return async (dispatch: any) => {

    await dispatch(checkingPreload());

    const result = await desactiveEmployeService(employeId, value, pagePagination, take, status);


    dispatch(unCheckingPreload());

    if (result.ok) {
      await dispatch(setEmployesRedux(result.data));
    }

    return result;

  }


}




export const storeActiveEmploye = (employeId: string, value: string, pagePagination: number = 1, take: number = 10, status: number = 1): any => {


  return async (dispatch: any) => {

    await dispatch(checkingPreload());

    const result = await activeEmployeService(employeId, value, pagePagination, take, status);


    dispatch(unCheckingPreload());

    if (result.ok) {
      await dispatch(setEmployesRedux(result.data));
    }

    return result;

  }


}


// TRAE EL DETALLE DE UN USUARIO ESPECIFICO 
export const storeDetailEmployee = (employeeId: string): any => {

  return async (dispatch: any) => {



    await dispatch(checkingPreload());

    const result = await getEmployeeDetailService(employeeId);


    if (result.ok) {

      await dispatch(setEmployeRedux(result.data));
    }

    dispatch(unCheckingPreload());

    return result;


  }


}





export const storeShowDetailEmployeeEditar = (employeeId: string): any => {

  return async (dispatch: any) => {



    await dispatch(checkingPreload());

    const result = await getEmployeeDetailEditService(employeeId);

    if (result.ok) {

      await dispatch(dataCreateOrEditEmployee(result));
      await dispatch(setEmployeRedux(result.data.employee));
    }

    dispatch(unCheckingPreload());

    return result;


  }


}



export const setEmployeeRedux = (employee: object[]): any => {

  return async (dispatch: any) => {

    await dispatch(checkingPreload());

    // dispatch( setEmployeRedux(employee) )

    await dispatch(unCheckingPreload());

  }
}




const dataCreateOrEditEmployee = (result: any): any => {

  return async (dispatch: any) => {

    console.log("dataCreateOrEditEmployee",result)
    await dispatch(setCompanySelectRedux(result.data.company));
    await dispatch(setCargosSelectRedux(result.data.cargos));
    await dispatch(setPaymentFrecuencySelectRedux(result.data.paymentFrecuency));
    await dispatch(setBancosSelectRedux(result.data.bancos));
    await dispatch(setEpsSelectRedux(result.data.eps));
    await dispatch(setCajaCompensacionSelectRedux(result.data.cajaCompensacion));
    await dispatch(setCesantiasSelectRedux(result.data.cesantias));
    await dispatch(setCajaArlSelectRedux(result.data.arls));
    await dispatch(setPensionSelectRedux(result.data.pensiones));
    await dispatch(setTipoDocumentoSelectRedux(result.data.tipoDocumentos));
    await dispatch(setMetodoPagoSelectRedux(result.data.metodoPago));
    await dispatch(setSucursalesSelectRedux(result.data.sucursales));
    await dispatch(setEmployeesContractsRedux(result.data.contracts));

  }
}


export const storeVerifyEmail = (email: string): any => {
  return async (dispatch: any) => {

    await dispatch(checkingPreload());
    const result = await verifyEmailService(email);
    await dispatch(unCheckingPreload());
    return result;
  }
}


export const storeEntregarDotaciones = (dotacionIds: string[]): any => {
  return async (dispatch: any) => {

    await dispatch(checkingPreload());
    const result = await entregarDotacionesService(dotacionIds);
    await dispatch(unCheckingPreload());
    return result;
  }
}

export const storeDownloadActaPdf = (actaId: string): any => {
  return async (dispatch: any) => {

    await dispatch(checkingPreload());
    const blob = await downloadActaPdfService(actaId);
    await dispatch(unCheckingPreload());
    return blob;
  }
}

export const storeDownloadContractPdf = (employeeId: string): any => {
  return async (dispatch: any) => {

    await dispatch(checkingPreload());
    const blob = await downloadContractPdfService(employeeId);
    await dispatch(unCheckingPreload());
    return blob;
  }
}

export const storeUpdateEmployeeContractPdf = (employeeId: string, filename: string): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());
    const result = await updateEmployeeService({ empleadoId: employeeId, file_signed_contract_name: filename });
    await dispatch(unCheckingPreload());
    return result;
  }
}

export const storeDownloadPdfEmployee = (filename: string): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());
    const blob = await downloadPdfEmployeeService(filename);
    await dispatch(unCheckingPreload());
    return blob;
  }
}
